import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { Box, ChakraProvider } from '@chakra-ui/react'
import Home from './pages/Home.jsx'
import About from './pages/About.jsx'
import Products from './pages/Products.jsx'
import Contact from './pages/Contact.jsx'
import Admin from './pages/Admin.jsx'
import Product from './pages/Product.jsx'
import NotFound from './pages/404.jsx'
import PrivacyPolicy from './pages/PrivacyPolicy.jsx'
import './index.css'
import LoadingLogo from './components/LoadingLogo/index.jsx'
import LangSync from './components/LangSync/index.jsx'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    const MIN_TIME = 3000
    const startTime = Date.now()

    const images = Array.from(document.images)
    let loaded = 0

    const checkAllLoaded = () => {
      loaded++
      if (loaded === images.length) {
        const elapsed = Date.now() - startTime
        const remaining = Math.max(MIN_TIME - elapsed, 0)
        setTimeout(() => {
          setFadeOut(true)
          setTimeout(() => {
            setIsLoading(false)
          }, 1000) // match transition duration in CSS
        }, remaining)
      }
    }

    if (images.length === 0) {
      const remaining = Math.max(MIN_TIME - (Date.now() - startTime), 0)
      setTimeout(() => {
        setFadeOut(true)
        setTimeout(() => {
          setIsLoading(false)
        }, 1000)
      }, remaining)
      return
    }

    images.forEach((img) => {
      if (img.complete) {
        checkAllLoaded()
      } else {
        img.addEventListener('load', checkAllLoaded)
        img.addEventListener('error', checkAllLoaded)
      }
    })

    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', checkAllLoaded)
        img.removeEventListener('error', checkAllLoaded)
      })
    }
  }, [])

  return (
    <>
      {isLoading && (
        <div className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}>
          <LoadingLogo />
        </div>
      )}


      <div className="App">
        <Router>
          <LangSync />
          <ChakraProvider>
            <Box>
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<Product />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<Navigate to="/404" />} />
              </Routes>
            </Box>
          </ChakraProvider>
        </Router>
      </div>
    </>
  )
}

export default App
